import "./PageContent.scss";

import type * as React from "react";

interface PageContentProps extends React.HTMLAttributes<HTMLDivElement> {
  layout?: "row" | "column"; // | 'static';
  scrollable?: boolean;
}

export const PageContent: React.FC<PageContentProps> = ({
  layout = "row",
  className,
  scrollable = true,
  children,
  ...otherProps
}) => {
  const scrollClass = scrollable ? "scrollable" : null;
  const classes = ["page-content", className, layout, scrollClass].join(" ");
  return (
    <section className={classes} {...otherProps}>
      {children}
    </section>
  );
};

export default PageContent;
